<script setup>
import { DocumentTextIcon } from '@heroicons/vue/outline'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { computed } from 'vue'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { i18n } from '../../../localization'

const manualSignature = computed(() => {
    return useInvestmentProcessDataState().createdOrder.emission_signatures.filter(
        (signature) => signature.type === 'manual'
    )
})
const sproofSignature = computed(() => {
    return useInvestmentProcessDataState().createdOrder.emission_signatures.find(
        (signature) => signature.type === 'sproof'
    )
})

function openSproofSignature() {
    window.open(sproofSignature.value.link, '_blank')
}

function openManualSignature() {
    manualSignature.value.forEach((signature) => {
        window.open(signature.link, '_blank')
    })
}

const signatureNotice = computed(() => {
    if (i18n.global.t('investment_process.signature_legal_notice')) {
        return i18n.global.t('investment_process.signature_legal_notice')
    } else {
        return getCampaignData().asset_data.signature_legal_notice
    }
})
</script>

<template>
    <div v-if="sproofSignature || manualSignature" class="overflow-hidden rounded-lg border">
        <div class="px-6 py-4">
            <h3 class="flex text-xl font-bold text-gray-900">
                <DocumentTextIcon class="mr-2 w-5" />
                {{ $t('investment_process.signature_legal_notice_title') }}
            </h3>
            <p class="my-2 font-medium text-gray-500" v-html="signatureNotice"></p>
            <div class="flex items-center">
                <BaseButtonMuted v-if="sproofSignature" size="lg" class="flex-1" @click="openSproofSignature">
                    {{ $t('investment_process.sign_digitally') }}
                </BaseButtonMuted>
                <div v-if="manualSignature && sproofSignature" class="px-4">
                    {{ $t('investment_process.or') }}
                </div>
                <BaseButtonMuted v-if="manualSignature" size="lg" class="flex-1" @click="openManualSignature">
                    {{ $t('investment_process.download_signature_document') }}
                </BaseButtonMuted>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
